(function () {
  var instances = new WeakMap();
  var observer = null;

  function initAll() {
    document.querySelectorAll('cart-element[data-view="drawer"]').forEach(initCart);
  }

  function initCart(cart) {
    var body = cart.querySelector(".cart--body");
    var bar = cart.querySelector("[data-cart-body-scrollbar]");
    var thumb = cart.querySelector("[data-cart-body-scrollbar-thumb]");

    if (!body || !bar || !thumb) {
      return;
    }

    var current = instances.get(cart);
    if (current && current.body === body) {
      current.requestUpdate();
      return;
    }

    if (current) {
      current.destroy();
    }

    var frame = null;
    var dragging = false;
    var dragStartY = 0;
    var dragStartScrollTop = 0;

    function update() {
      frame = null;

      var clientHeight = body.clientHeight;
      var scrollHeight = body.scrollHeight;
      var maxScroll = scrollHeight - clientHeight;

      bar.style.top = body.offsetTop + "px";
      bar.style.height = clientHeight + "px";

      if (maxScroll <= 1 || clientHeight <= 0) {
        bar.classList.remove("is-visible");
        return;
      }

      var thumbHeight = Math.max(Math.round((clientHeight * clientHeight) / scrollHeight), 32);
      thumbHeight = Math.min(thumbHeight, clientHeight);

      var maxThumbTravel = clientHeight - thumbHeight;
      var thumbTop = maxThumbTravel > 0 ? Math.round((body.scrollTop / maxScroll) * maxThumbTravel) : 0;

      thumb.style.height = thumbHeight + "px";
      thumb.style.transform = "translateY(" + thumbTop + "px)";
      bar.classList.add("is-visible");
    }

    function requestUpdate() {
      if (!frame) {
        frame = window.requestAnimationFrame(update);
      }
    }

    function scrollToPointer(event) {
      var clientHeight = body.clientHeight;
      var scrollHeight = body.scrollHeight;
      var maxScroll = scrollHeight - clientHeight;
      var maxThumbTravel = clientHeight - thumb.offsetHeight;

      if (maxScroll <= 0 || maxThumbTravel <= 0) {
        return;
      }

      var rect = bar.getBoundingClientRect();
      var pointerTop = event.clientY - rect.top - thumb.offsetHeight / 2;
      body.scrollTop = Math.max(0, Math.min(maxScroll, (pointerTop / maxThumbTravel) * maxScroll));
    }

    function onThumbPointerDown(event) {
      event.preventDefault();
      dragging = true;
      dragStartY = event.clientY;
      dragStartScrollTop = body.scrollTop;
      bar.classList.add("is-dragging");

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp, { once: true });
    }

    function onTrackPointerDown(event) {
      if (event.target === thumb) {
        return;
      }

      event.preventDefault();
      scrollToPointer(event);
    }

    function onPointerMove(event) {
      if (!dragging) {
        return;
      }

      var clientHeight = body.clientHeight;
      var scrollHeight = body.scrollHeight;
      var maxScroll = scrollHeight - clientHeight;
      var maxThumbTravel = clientHeight - thumb.offsetHeight;

      if (maxScroll <= 0 || maxThumbTravel <= 0) {
        return;
      }

      body.scrollTop = dragStartScrollTop + (event.clientY - dragStartY) * (maxScroll / maxThumbTravel);
    }

    function onPointerUp() {
      dragging = false;
      bar.classList.remove("is-dragging");
      document.removeEventListener("pointermove", onPointerMove);
    }

    var resizeObserver = new ResizeObserver(requestUpdate);
    resizeObserver.observe(body);
    resizeObserver.observe(cart);

    body.addEventListener("scroll", requestUpdate, { passive: true });
    thumb.addEventListener("pointerdown", onThumbPointerDown);
    bar.addEventListener("pointerdown", onTrackPointerDown);

    instances.set(cart, {
      body: body,
      requestUpdate: requestUpdate,
      destroy: function () {
        body.removeEventListener("scroll", requestUpdate);
        thumb.removeEventListener("pointerdown", onThumbPointerDown);
        bar.removeEventListener("pointerdown", onTrackPointerDown);
        document.removeEventListener("pointermove", onPointerMove);
        resizeObserver.disconnect();

        if (frame) {
          window.cancelAnimationFrame(frame);
        }
      },
    });

    requestUpdate();
  }

  function observeCartDrawer() {
    var container = document.querySelector('.drawer--container[data-view="cart-drawer"]');

    if (!container || observer) {
      return;
    }

    observer = new MutationObserver(function () {
      window.requestAnimationFrame(initAll);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function load() {
    initAll();
    observeCartDrawer();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", load);
  } else {
    load();
  }

  window.addEventListener("resize", initAll);
  window.addEventListener("theme:cart:updated", initAll);
  window.addEventListener("theme:drawer:right:opened", initAll);
})();
